export default __webpack_public_path__ + "static/src/companys/scb/assets/images/logo/logo.png";